<h4 id="actual-category-text-top">Actual Categories</h4>
<div class="panel panel-white">
    <div class="panel-heading border-light">
        <div class="actual-costing-header">
            <h4 class="panel-title" id="actual-category-text">Actual Categories</h4>
            <div class="margin-0 checkbox clip-check check-primary check-inline">
                <input
                    legacy-css
                    type="checkbox"
                    name="costingsSelectAll"
                    id="costingsSelectAll"
                    [(ngModel)]="allSelected"
                    (change)="selectAllChanged()" />
                <label for="costingsSelectAll"><span id="select-all-text" class="heading-text">Select All</span> </label>
            </div>
            <button
                type="button"
                class="btn btn-bx-primary"
                (click)="addCategory(itemsForm)"
                tooltip="Create New Category"
                container="body">
                Create New Category
            </button>
        </div>

        <ul class="panel-heading-tabs border-light">
            <li class="d-flex">
                <div class="input-wrapper">
                    <i class="prefix fa-light fa-magnifying-glass"></i>
                    <input
                        [value]="filterInput$ | async"
                        #searchInput
                        (input)="filterInput$.next(searchInput.value)"
                        class="text-input"
                        placeholder="Search" />
                    <button
                        id="job-actual-costing-filter-search-reset"
                        class="suffix btn-flat btn-small square"
                        (click)="filterInput$.next('')">
                        <i class="fa-light fa-xmark"></i>
                    </button>
                </div>
            </li>
            <li>
                <div class="btn-group dropdown" dropdown>
                    <button
                        type="button"
                        class="btn btn-default dropdown-toggle"
                        dropdownToggle
                        [disabled]="editModes.items"
                        aria-haspopup="true"
                        aria-expanded="false">
                        <i class="ti-settings"></i>
                        <span class="caret margin-left-5"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right no-max-height" role="menu">
                        @if (!hasCompactJobs) {
                            <li>
                                <a (click)="printJobCostingsEstVsAct()"
                                    ><i class="ti-printer"></i>
                                    Print Estimated vs Actuals
                                </a>
                            </li>
                            <li>
                                <a (click)="emailJobCostingsEstVsAct()"
                                    ><i class="far fa-envelope"></i>
                                    Email Estimated vs Actuals
                                </a>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <a (click)="printJobCostingsEstVsComm()"
                                    ><i class="ti-printer"></i>
                                    Print Estimated vs Committed
                                </a>
                            </li>
                            <li>
                                <a (click)="emailJobCostingsEstVsComm()"
                                    ><i class="far fa-envelope"></i>
                                    Email Estimated vs Committed
                                </a>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <a id="PrintPSPC" (click)="printJobCostingsPCPS()"
                                    ><i class="ti-printer"></i> Print <span translate="general.pc-ps"></span>
                                    Items
                                </a>
                            </li>
                            <li>
                                <a id="EmailPSPC" (click)="emailJobCostingsPCPS()"
                                    ><i class="far fa-envelope"></i> Email <span translate="general.pc-ps"></span>
                                    Items
                                </a>
                            </li>
                            <li class="divider"></li>
                        }
                        <li><a (click)="exportItems()">Export to Excel</a></li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
    <div class="panel-body">
        <div class="col-xs-12 text-center" *ngIf="jobItems?.length === 0">
            <h2 class="margin-top-30 margin-bottom-30">Click the + button above to start adding actual costs...</h2>
        </div>

        <form #itemsForm="ngForm" novalidate>
            <div class="form-group">
                <div class="panel-group">
                    <accordion class="items-accordion" [closeOthers]="true" cdkDropList (cdkDropListDropped)="dropCategory($event)">
                        <accordion-group
                            *ngFor="let jobItem of jobItems | simpleFilter: { MatchesSearchText: true }; let i = index"
                            [panelClass]="'panel-default'"
                            [isOpen]="jobItem.isOpen"
                            [isDisabled]="!itemsForm.valid"
                            [appScrollToTop]="jobItem.isOpen"
                            (isOpenChange)="setSelectedCategory($event, jobItem)"
                            cdkDrag
                            cdkDragBoundary=".items-accordion">
                            <div accordion-heading>
                                <h4 class="panel-title">
                                    <div class="accordion-toggle">
                                        <table class="category-table">
                                            <tbody>
                                                <tr>
                                                    <td class="grip-col">
                                                        <div class="grip-container" cdkDragHandle>
                                                            <span class="grip"></span>
                                                            {{ jobItem.DisplayedOrderNumber }}
                                                        </div>
                                                    </td>
                                                    <td class="pr-2">
                                                        <div class="margin-0 checkbox clip-check check-primary">
                                                            <input
                                                                legacy-css
                                                                name="{{ jobItem.ID_JobItem }}check"
                                                                type="checkbox"
                                                                id="{{ jobItem.ID_JobItem }}check"
                                                                [(ngModel)]="jobItem.selected"
                                                                [disabled]="!jobItem.Description"
                                                                (change)="selectedCategoryChanged(jobItem)" /><label
                                                                style="margin-right: 0; padding-left: 0 !important"
                                                                for="{{ jobItem.ID_JobItem }}check"></label>
                                                        </div>
                                                    </td>
                                                    <td class="description-col">
                                                        <span [innerHTML]="getHighLightMatchedText(jobItem.Description)"></span>
                                                    </td>
                                                    <td
                                                        class="estimated-cost-col hidden-on-mobile"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                        <span tooltip="Estimated Total (Ex)">{{ jobItem.EstimatedCost | bxCurrency }}</span>
                                                    </td>
                                                    <td
                                                        class="actual-cost-col hidden-on-mobile"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-actual')">
                                                        <span tooltip="Actual Total (Ex)">{{ jobItem.ActualCost | bxCurrency }}</span>
                                                    </td>
                                                    <td
                                                        class="variance-cost-col hidden-on-mobile"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-variance')">
                                                        <span tooltip="Variance (Ex)">{{ jobItem.VarianceCost | bxCurrency }}</span>
                                                    </td>
                                                    <td class="variance-percent-col">
                                                        <span
                                                            class="label"
                                                            [ngClass]="{
                                                                'label-danger': jobItem.VarianceCost < 0,
                                                                'label-success': jobItem.VarianceCost >= 0,
                                                            }"
                                                            *ngIf="jobItem.VariancePercent !== 0">
                                                            {{ jobItem.VariancePercent }}%
                                                        </span>
                                                    </td>
                                                    <td class="actions-col">
                                                        <div
                                                            tooltip="{{
                                                                jobItem.hasReceivedOrders
                                                                    ? 'This category cannot be deleted because it contains item(s) that are linked to a received Purchase Order or Work Order.'
                                                                    : 'Delete category'
                                                            }}"
                                                            container="body">
                                                            <button
                                                                type="button"
                                                                class="btn btn-danger btn-sm"
                                                                [attr.pointer-events]="
                                                                    !isDeleteCategoryEnabled ||
                                                                    editModes.items ||
                                                                    jobItem.IsReadOnly ||
                                                                    jobItem.hasReceivedOrders
                                                                        ? 'none'
                                                                        : ''
                                                                "
                                                                [disabled]="
                                                                    !isDeleteCategoryEnabled ||
                                                                    editModes.items ||
                                                                    jobItem.IsReadOnly ||
                                                                    jobItem.hasReceivedOrders
                                                                "
                                                                (click)="deleteCategory($event, jobItem)">
                                                                <i class="ti-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </h4>
                            </div>
                            <div class="panel-body" *ngIf="jobItem.isOpen">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <h3 class="margin-top-10 pull-left" *ngIf="!(editModes.items && !jobItem.IsReadOnly)">
                                            {{ jobItem.Description }}
                                        </h3>
                                        <input
                                            legacy-css
                                            id="{{ jobItem.ID_JobItem }}"
                                            name="{{ jobItem.ID_JobItem }}"
                                            type="text"
                                            class="input-lg pull-left width-280"
                                            style="font-size: 18px !important"
                                            [(ngModel)]="jobItem.Description"
                                            required
                                            *ngIf="editModes.items && !jobItem.IsReadOnly"
                                            appSelectAllOnFocus
                                            appSelectAllOnFocusFilter="New Category"
                                            appNullReplace="New Category" />
                                        @if (!hasCompactJobs) {
                                            <div class="form-inline pull-right">
                                                <div class="form-group margin-top-5">
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    class="text-right"
                                                                    *ngIf="
                                                                        permissionService.isAvailable(
                                                                            'jobs.maintain-job-costings.view-estimated'
                                                                        )
                                                                    ">
                                                                    Estimated (Ex)
                                                                </th>
                                                                <th
                                                                    class="text-right"
                                                                    *ngIf="
                                                                        permissionService.isAvailable(
                                                                            'jobs.maintain-job-costings.view-actual'
                                                                        )
                                                                    ">
                                                                    Actual (Ex)
                                                                </th>
                                                                <th
                                                                    class="text-right"
                                                                    *ngIf="
                                                                        permissionService.isAvailable(
                                                                            'jobs.maintain-job-costings.view-variance'
                                                                        )
                                                                    ">
                                                                    Variance (Ex)
                                                                </th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    class="text-right min-width-100"
                                                                    *ngIf="
                                                                        permissionService.isAvailable(
                                                                            'jobs.maintain-job-costings.view-estimated'
                                                                        )
                                                                    ">
                                                                    <h3 class="padding-left-20">
                                                                        {{ jobItem.EstimatedCost | bxCurrency }}
                                                                    </h3>
                                                                </td>
                                                                <td
                                                                    class="text-right min-width-100"
                                                                    *ngIf="
                                                                        permissionService.isAvailable(
                                                                            'jobs.maintain-job-costings.view-actual'
                                                                        )
                                                                    ">
                                                                    <h3 style="padding-left: 20px">
                                                                        {{ jobItem.ActualCost | bxCurrency }}
                                                                    </h3>
                                                                </td>
                                                                <td
                                                                    class="text-right min-width-100"
                                                                    *ngIf="
                                                                        permissionService.isAvailable(
                                                                            'jobs.maintain-job-costings.view-variance'
                                                                        )
                                                                    ">
                                                                    <h3 class="padding-left-20">{{ jobItem.VarianceCost | bxCurrency }}</h3>
                                                                </td>
                                                                <td>
                                                                    <h4 class="padding-left-20">
                                                                        <span
                                                                            class="label"
                                                                            [ngClass]="{
                                                                                'label-danger': jobItem.VarianceCost < 0,
                                                                                'label-success': jobItem.VarianceCost > 0,
                                                                            }"
                                                                            *ngIf="jobItem.VariancePercent !== 0"
                                                                            >{{ jobItem.VariancePercent }}%
                                                                        </span>
                                                                    </h4>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-xs-12">
                                        <div class="form-group pull-right">
                                            <div class="btn-group category-toolbar">
                                                <button
                                                    type="button"
                                                    *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.add-cost-item')"
                                                    class="btn btn-success hidden-on-mobile"
                                                    [disabled]="!permissionService.isAvailable('jobs.maintain-job-costings.modify-actual')"
                                                    (appSingleClick)="addItem(jobItem, itemsForm)"
                                                    tooltip="Add item"
                                                    container="true">
                                                    <i class="ti-plus"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.add-cost-item')"
                                                    class="btn btn-success hidden-not-on-mobile"
                                                    [disabled]="!permissionService.isAvailable('jobs.maintain-job-costings.modify-actual')"
                                                    (click)="addItemModal(jobItem)"
                                                    tooltip="Add item"
                                                    container="true">
                                                    <i class="ti-plus"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    tooltip="Modify items"
                                                    container="body"
                                                    *ngIf="
                                                        !editModes.items &&
                                                        permissionService.isAvailable('jobs.maintain-job-costings.edit-category')
                                                    "
                                                    [disabled]="!permissionService.isAvailable('jobs.maintain-job-costings.modify-actual')"
                                                    class="btn btn-info hidden-on-mobile"
                                                    (click)="startEditing(itemsForm)">
                                                    <i class="ti-pencil"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-warning hidden-on-mobile"
                                                    *ngIf="editModes.items"
                                                    (click)="stopEditing(itemsForm)"
                                                    [disabled]="!itemsForm.valid">
                                                    <i class="ti-check"></i>
                                                    Save
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-default hidden-on-mobile"
                                                    *ngIf="editModes.items"
                                                    (click)="cancelEditing()">
                                                    <i class="ti-close"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <table class="table table-hover items-table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Select</th>
                                                <th>Description</th>
                                                <th class="hidden-on-mobile"></th>
                                                <th class="hidden-on-mobile"></th>
                                                <th class="text-left hidden-on-mobile" *ngIf="job().CalculationMethod >= 1">Type</th>
                                                <th
                                                    class="text-right hidden-on-mobile"
                                                    *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                    Est. Qty
                                                </th>
                                                <th
                                                    class="text-center hidden-on-mobile"
                                                    *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                    UOM
                                                </th>
                                                <th
                                                    class="text-right hidden-on-mobile"
                                                    *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                    Est. Unit
                                                </th>
                                                <th
                                                    class="text-right hidden-on-mobile"
                                                    *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                    Est. Total
                                                </th>
                                                <th
                                                    class="text-center hidden-on-mobile"
                                                    *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                    Ordered
                                                </th>
                                                <th
                                                    class="text-right hidden-on-mobile"
                                                    *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-actual')">
                                                    Act. Qty
                                                </th>
                                                <th
                                                    class="text-right min-width-100"
                                                    *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-actual')">
                                                    Act. Total
                                                </th>
                                                <th class="text-center hidden-on-mobile" *ngIf="job().CalculationMethod >= 1">
                                                    {{ taxCode }}
                                                </th>
                                                @if (!hasCompactJobs) {
                                                    <th
                                                        class="text-right hidden-on-mobile"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-variance')">
                                                        Variance
                                                    </th>
                                                    <th
                                                        class="hidden-on-mobile"
                                                        *ngIf="
                                                            permissionService.isAvailable('jobs.maintain-job-costings.view-variance')
                                                        "></th>
                                                }
                                                <th class="hidden-on-mobile">Notes</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody class="items-table-body" cdkDropList (cdkDropListDropped)="dropItem($event)">
                                            <ng-container
                                                *ngFor="
                                                    let item of jobItem?.children!
                                                        | simpleFilter: { IsDeleted: false }
                                                        | simpleFilter: { MatchesSearchText: true }
                                                        | simpleSort: 'OrderNumber';
                                                    let i = index
                                                ">
                                                <tr
                                                    (dblclick)="startEditing(itemsForm)"
                                                    id="itemsRow{{ item.ID_JobItem }}"
                                                    cdkDrag
                                                    cdkDragBoundary=".items-table-body">
                                                    <td class="condensed-col width-50">
                                                        <div class="grip-container" cdkDragHandle>
                                                            <span class="grip"></span>
                                                            {{ item.DisplayedOrderNumber }}
                                                        </div>
                                                    </td>
                                                    <td class="condensed-col width-50">
                                                        <div class="margin-0 checkbox clip-check check-primary">
                                                            <input
                                                                legacy-css
                                                                type="checkbox"
                                                                id="{{ item.ID_JobItem }}check"
                                                                name="{{ item.ID_JobItem }}check"
                                                                [(ngModel)]="item.selected"
                                                                (ngModelChange)="selectedChanged(item)" />
                                                            <label
                                                                style="margin-right: 0; margin-left: 8px; padding-left: 0 !important"
                                                                for="{{ item.ID_JobItem }}check">
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td class="col-sm-4 condensed-col hidden-on-mobile">
                                                        <div
                                                            class="full-width input-group input-group-sm"
                                                            *ngIf="editModes.items && !item.IsReadOnly && !item.variation">
                                                            <input
                                                                legacy-css
                                                                type="text"
                                                                class="form-control"
                                                                [(ngModel)]="item.Description"
                                                                id="{{ item.ID_JobItem }}"
                                                                name="{{ item.ID_JobItem }}"
                                                                placeholder="New Item"
                                                                editable-form-focus
                                                                appSelectAllOnFocus
                                                                appSelectAllOnFocusFilter="New Item"
                                                                appNullReplace="Item Description"
                                                                maxlength="255" />
                                                            <span class="input-group-btn" *ngIf="item.ItemType">
                                                                <button
                                                                    type="button"
                                                                    class="btn"
                                                                    [ngClass]="{
                                                                        'btn-light-purple': item.ItemType === 1,
                                                                        'btn-dark-beige': item.ItemType === 2,
                                                                    }">
                                                                    {{ item.ItemTypeCode }}
                                                                </button>
                                                            </span>
                                                        </div>
                                                        <span
                                                            [hidden]="(editModes.items && !item.IsReadOnly) || item.variation"
                                                            [innerHTML]="getHighLightMatchedText(item.Description)"></span>
                                                        <div *ngIf="editModes.items && item.EstimateItem?.Notes?.length > 0">
                                                            <span
                                                                legacy-css
                                                                class="estimate-item-note"
                                                                name="Notes"
                                                                [attr.id]="item.ID_JobItem + '_estimateNotes'"
                                                                >Estimate Note: {{ item.EstimateItem.Notes }}</span
                                                            >
                                                        </div>
                                                        <a *ngIf="item.variation" (click)="viewVariation(item.variation)">
                                                            {{ item.Description }}
                                                        </a>
                                                        <span
                                                            *ngIf="item.ItemType && !editModes.items"
                                                            class="label pull-right"
                                                            [ngClass]="{
                                                                'label-light-purple': item.ItemType === 1,
                                                                'label-dark-beige': item.ItemType === 2,
                                                            }"
                                                            >{{ getItemCodeLabel(item.ItemTypeCode) }}</span
                                                        >
                                                    </td>
                                                    <td class="condensed-col hidden-on-mobile">
                                                        <i
                                                            *ngIf="!editModes.items && item.EstimateItem?.Notes?.length > 0"
                                                            class="pull-right fa fa-align-left padding-right-5 padding-top-5"
                                                            [tooltip]="item.EstimateItem.Notes"></i>
                                                    </td>
                                                    <td class="condensed-col hidden-not-on-mobile">
                                                        <p>{{ item.Description }}</p>
                                                        <div class="col-xs-12 margin-bottom-5 padding-0">
                                                            <span
                                                                *ngIf="
                                                                    permissionService.isAvailable(
                                                                        'jobs.maintain-job-costings.view-variance'
                                                                    )
                                                                "
                                                                >{{ item.VarianceCost | bxCurrency }}</span
                                                            >
                                                            <span
                                                                *ngIf="
                                                                    item.VariancePercent !== 0 &&
                                                                    permissionService.isAvailable(
                                                                        'jobs.maintain-job-costings.view-variance'
                                                                    )
                                                                "
                                                                class="label text-small margin-left-20"
                                                                [ngClass]="{
                                                                    'label-danger': item.VarianceCost < 0,
                                                                    'label-success': item.VarianceCost >= 0,
                                                                }">
                                                                {{ item.VariancePercent }}%
                                                            </span>
                                                            <span
                                                                *ngIf="item.ItemType"
                                                                class="label margin-left-20"
                                                                [ngClass]="{
                                                                    'label-light-purple': item.ItemType === 1,
                                                                    'label-dark-beige': item.ItemType === 2,
                                                                }"
                                                                >{{ getItemCodeLabel(item.ItemTypeCode) }}</span
                                                            >
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="condensed-col hidden-on-mobile"
                                                        [ngClass]="{
                                                            'min-width-80':
                                                                item.CostItem &&
                                                                item.CostItem.PriceList &&
                                                                item.CostItem.PriceList.ShortCode,
                                                        }">
                                                        <app-catalogue-item-link-tile
                                                            [item]="item"
                                                            *ngIf="item.CostItem?.PriceList?.ShortCode"
                                                            [excludeRecipes]="true"
                                                            (costItemChanged)="setCostItem(item, $event)"
                                                            [actionsEnabled]="!item.IsReadOnly"
                                                            class="condensed-col inline-block"
                                                            [showSupplierQuoteStatus]="item.SupplierOrderQuoteId"
                                                            [textHtml]="
                                                                item.SupplierOrderQuoteId ? 'THD' : item.CostItem.PriceList.ShortCode
                                                            "
                                                            [tileColour]="item.CostItem.PriceList.Colour">
                                                        </app-catalogue-item-link-tile>
                                                        <app-ui-item-code-pill
                                                            [itemState]="item"
                                                            *ngIf="!item.CostItem && item.ItemCode"
                                                            [actionsEnabled]="!item.IsReadOnly"
                                                            (itemCodeCleared)="clearItemCode(item)">
                                                        </app-ui-item-code-pill>
                                                        <ng-container *ngIf="rfqJobs">
                                                            <div
                                                                *ngIf="item.ID_QuoteRequest"
                                                                class="condensed-col inline-block vertical-align-top">
                                                                <a [routerLink]="['../../quoterequests']" class="margin-left-15">
                                                                    <span
                                                                        class="label label-min-75-grid"
                                                                        style="padding: 0.2rem 0.4rem !important"
                                                                        [ngClass]="getQuoteRequestClassForJobItem(item)"
                                                                        tooltip="Quote request item"
                                                                        *ngIf="getQuoteRequestStatusForJobItem(item)">
                                                                        {{ getQuoteRequestNumberForJobItem(item) }}
                                                                        <br />
                                                                        <small>
                                                                            {{ getQuoteRequestStatusForJobItem(item) }}
                                                                        </small>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div
                                                                class="condensed-col inline-block vertical-align-top"
                                                                *ngIf="item.EstimateItem?.ID_QuoteRequest">
                                                                <a [routerLink]="['/quoterequests', 'list']" class="margin-left-15">
                                                                    <span
                                                                        class="label label-min-75-grid"
                                                                        style="padding: 0.2rem 0.4rem !important"
                                                                        [ngClass]="getQuoteRequestClassForEstimateItem(item.EstimateItem)"
                                                                        tooltip="Quote request item"
                                                                        *ngIf="getQuoteRequestStatusForEstimateItem(item.EstimateItem)">
                                                                        {{ getQuoteRequestNumberForEstimateItem(item.EstimateItem) }}
                                                                        <br />
                                                                        <small>
                                                                            {{ getQuoteRequestStatusForEstimateItem(item.EstimateItem) }}
                                                                        </small>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </ng-container>
                                                    </td>
                                                    <td
                                                        class="text-left condensed-col min-width-120 hidden-on-mobile"
                                                        *ngIf="job().CalculationMethod >= 1">
                                                        <span *ngIf="!(editModes.items && !item.IsReadOnly && !item.hasOrders)">{{
                                                            taxService.costItemTypeToDisplay(item.CostItemType)
                                                        }}</span>
                                                        <select
                                                            legacy-css
                                                            *ngIf="editModes.items && !item.IsReadOnly && !item.hasOrders"
                                                            class="form-control"
                                                            id="{{ item.ID_JobItem }}costItemType"
                                                            name="{{ item.ID_JobItem }}costItemType"
                                                            [(ngModel)]="item.CostItemType">
                                                            <option *ngFor="let c of taxService.allCostItemTypePairs()" [ngValue]="c.cit">
                                                                {{ c.display }}
                                                            </option>
                                                        </select>
                                                    </td>
                                                    <td
                                                        class="text-right width-80 condensed-col hidden-on-mobile"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                        <span
                                                            *ngIf="
                                                                !(
                                                                    editModes.items &&
                                                                    !item.IsReadOnly &&
                                                                    (!job().HasEstimate || (job().HasEstimate && job().InvoiceMethod == 1))
                                                                )
                                                            "
                                                            >{{ item.EstimatedQty | imperial: item.IsImperial }}</span
                                                        >
                                                        <div
                                                            class="input-group input-group-sm"
                                                            *ngIf="
                                                                editModes.items &&
                                                                !item.IsReadOnly &&
                                                                (!job().HasEstimate || (job().HasEstimate && job().InvoiceMethod == 1))
                                                            ">
                                                            <input
                                                                legacy-css
                                                                type="text"
                                                                class="form-control text-right"
                                                                [(ngModel)]="item.EstimatedQty"
                                                                id="{{ item.ID_JobItem }}estimatedQty"
                                                                name="{{ item.ID_JobItem }}estimatedQty"
                                                                appNumeric
                                                                appSelectAllOnFocus
                                                                [decimals]="3"
                                                                [imperial]="item.IsImperial"
                                                                appNullReplace="0" />
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="text-center width-100 condensed-col hidden-on-mobile"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                        <span
                                                            *ngIf="
                                                                !(
                                                                    editModes.items &&
                                                                    !item.IsReadOnly &&
                                                                    (!job().HasEstimate || (job().HasEstimate && job().InvoiceMethod == 1))
                                                                )
                                                            "
                                                            >{{ item.UOM }}</span
                                                        >
                                                        <div
                                                            *ngIf="
                                                                editModes.items &&
                                                                !item.IsReadOnly &&
                                                                (!job().HasEstimate || (job().HasEstimate && job().InvoiceMethod == 1))
                                                            ">
                                                            <input
                                                                legacy-css
                                                                type="text"
                                                                maxlength="50"
                                                                [(ngModel)]="item.UOM"
                                                                id="{{ item.ID_JobItem }}uom"
                                                                name="{{ item.ID_JobItem }}uom"
                                                                [typeahead]="unitMeasures"
                                                                class="form-control"
                                                                [typeaheadMinLength]="1"
                                                                container="body" />
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="text-right width-100 condensed-col hidden-on-mobile"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                        <span
                                                            *ngIf="
                                                                !(
                                                                    editModes.items &&
                                                                    !item.IsReadOnly &&
                                                                    (!job().HasEstimate || (job().HasEstimate && job().InvoiceMethod == 1))
                                                                )
                                                            "
                                                            >{{ item.EstimatedUnitCost | bxCurrency }}</span
                                                        >
                                                        <div
                                                            class="input-group input-group-sm"
                                                            *ngIf="
                                                                editModes.items &&
                                                                !item.IsReadOnly &&
                                                                (!job().HasEstimate || (job().HasEstimate && job().InvoiceMethod == 1))
                                                            ">
                                                            <input
                                                                legacy-css
                                                                type="text"
                                                                class="form-control text-right"
                                                                [(ngModel)]="item.EstimatedUnitCost"
                                                                id="{{ item.ID_JobItem }}estimatedUnitCost"
                                                                name="{{ item.ID_JobItem }}estimatedUnitCost"
                                                                [min]="0"
                                                                appCurrency
                                                                appSelectAllOnFocus />
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="text-right width-100 condensed-col hidden-on-mobile"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                        <a
                                                            (click)="item.showRelatedItems = !item.showRelatedItems"
                                                            *ngIf="item.hasVariations || item.hasRelatedQuoteRequest; else displayEstCost">
                                                            {{ item.EstimatedCost | bxCurrency }}
                                                        </a>
                                                        <ng-template #displayEstCost>
                                                            <span>{{ item.EstimatedCost | bxCurrency }}</span>
                                                        </ng-template>
                                                    </td>
                                                    <td
                                                        class="text-center condensed-col hidden-on-mobile"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                                                        <a
                                                            *ngIf="item.hasOrders && item.hasActiveOrders"
                                                            (click)="
                                                                item.showRelatedItems = !item.showRelatedItems; $event.preventDefault()
                                                            "
                                                            class="label label-info">
                                                            <i class="ti-check"></i>
                                                        </a>
                                                    </td>
                                                    <td
                                                        class="text-right width-80 condensed-col hidden-on-mobile"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-actual')">
                                                        <a
                                                            (click)="
                                                                item.showRelatedItems = !item.showRelatedItems; $event.preventDefault()
                                                            "
                                                            *ngIf="item.hasOrders && item.hasActiveOrders">
                                                            {{ item.ActualQty | imperial: item.IsImperial }}
                                                        </a>
                                                        <span *ngIf="!(item.hasOrders && item.hasActiveOrders)">{{
                                                            item.ActualQty | imperial: item.IsImperial
                                                        }}</span>
                                                    </td>
                                                    <td
                                                        class="text-right width-100 condensed-col"
                                                        *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-actual')">
                                                        <a
                                                            (click)="
                                                                item.showRelatedItems = !item.showRelatedItems; $event.preventDefault()
                                                            "
                                                            *ngIf="item.hasOrders && item.hasActiveOrders">
                                                            {{ item.ActualCost | bxCurrency }}
                                                        </a>
                                                        <span *ngIf="!(editModes.items || item.hasOrders)">{{
                                                            item.ActualCost | bxCurrency
                                                        }}</span>
                                                        <input
                                                            legacy-css
                                                            *ngIf="editModes.items && !item.hasActiveOrders"
                                                            type="text"
                                                            class="form-control text-right"
                                                            [(ngModel)]="item.ActualCost"
                                                            [ngModelOptions]="{ standalone: true }"
                                                            appCurrency
                                                            id="{{ item.ID_JobItem }}actualCost"
                                                            name="{{ item.ID_JobItem }}actualCost"
                                                            appNullReplace="0.00"
                                                            appSelectAllOnFocus />
                                                    </td>
                                                    <td
                                                        class="text-center condensed-col hidden-on-mobile"
                                                        *ngIf="job().CalculationMethod >= 1">
                                                        <tax-rate-selector
                                                            *ngIf="!item.hasOrders"
                                                            [editable]="editModes.items && !item.hasOrders"
                                                            [taxType]="1"
                                                            [costItemType]="item.CostItemType"
                                                            [selectedTaxCodes]="item.TaxRates"
                                                            [taxRatesParent]="job()"
                                                            (selectedChanged)="taxRatesChanged($event, item)"
                                                            [placement]="'left'"></tax-rate-selector>
                                                    </td>
                                                    @if (!hasCompactJobs) {
                                                        <td
                                                            class="text-right width-100 condensed-col hidden-on-mobile"
                                                            *ngIf="
                                                                permissionService.isAvailable('jobs.maintain-job-costings.view-variance')
                                                            ">
                                                            {{ item.VarianceCost | bxCurrency }}
                                                        </td>
                                                        <td
                                                            class="condensed-col hidden-on-mobile"
                                                            *ngIf="
                                                                permissionService.isAvailable('jobs.maintain-job-costings.view-variance')
                                                            ">
                                                            <span
                                                                class="label"
                                                                [ngClass]="{
                                                                    'label-danger': item.VarianceCost < 0,
                                                                    'label-success': item.VarianceCost >= 0,
                                                                }"
                                                                *ngIf="item.VariancePercent !== 0"
                                                                >{{ item.VariancePercent }}%</span
                                                            >
                                                        </td>
                                                    }
                                                    <td class="condensed-col min-width-140 hidden-on-mobile">
                                                        <div style="padding-left: 4px">
                                                            <span *ngIf="!editModes.items">{{ item.Notes }}</span>
                                                        </div>
                                                        <input
                                                            legacy-css
                                                            *ngIf="editModes.items"
                                                            type="text"
                                                            class="form-control"
                                                            id="{{ item.ID_JobItem }}notes"
                                                            name="{{ item.ID_JobItem }}notes"
                                                            [(ngModel)]="item.Notes" />
                                                    </td>
                                                    <td class="text-right width-30 condensed-col hidden-on-mobile">
                                                        <button
                                                            type="button"
                                                            class="btn btn-xs btn-danger"
                                                            *ngIf="
                                                                permissionService.isAvailable(
                                                                    'jobs.maintain-job-costings.delete-cost-item'
                                                                ) && !item.ID_QuoteRequest
                                                            "
                                                            (click)="deleteItem($event, item)"
                                                            [disabled]="item.IsReadOnly || item.hasOrders"
                                                            tooltip="Delete item"
                                                            container="body">
                                                            <i class="ti-trash"></i>
                                                        </button>
                                                    </td>
                                                    <td class="width-60 hidden-not-on-mobile">
                                                        <div class="btn-group" dropdown container="body">
                                                            <button
                                                                type="button"
                                                                class="btn btn-primary btn-o btn-sm dropdown-toggle"
                                                                dropdownToggle
                                                                aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <i class="ti-settings"></i>
                                                                <span class="caret"></span>
                                                            </button>
                                                            <ul
                                                                class="dropdown-menu dropdown-menu-right no-max-height"
                                                                *dropdownMenu
                                                                role="menu">
                                                                <li>
                                                                    <a (click)="_viewJobItemDetail(item, jobItem)">View...</a>
                                                                </li>
                                                                <li *ngIf="!item.IsReadOnly">
                                                                    <a
                                                                        *ngIf="
                                                                            permissionService.isAvailable(
                                                                                'jobs.maintain-job-costings.delete-cost-item'
                                                                            )
                                                                        "
                                                                        (click)="deleteItem($event, item)">
                                                                        Delete...
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="item.showRelatedItems">
                                                    <td></td>
                                                    <td></td>
                                                    <td *ngIf="item.showRelatedItems" colspan="8">
                                                        <app-job-actual-related-item
                                                            *ngIf="item.hasRelatedQuoteRequest"
                                                            [jobItem]="item"
                                                            [quoteRequests]="job().QuoteRequests">
                                                        </app-job-actual-related-item>

                                                        <h5 *ngIf="item.variations?.length" class="margin-bottom-0">
                                                            <strong>Related {{ 'general.variations' | translate }}</strong>
                                                        </h5>
                                                        <table *ngIf="item.variations?.length">
                                                            <tbody>
                                                                <tr class="height-30" *ngFor="let variationItem of item.variations">
                                                                    <td>
                                                                        <a (click)="viewVariation(variationItem.JobVariation)">
                                                                            {{ variationItem.JobVariation.VariationNo }} -
                                                                            {{ variationItem.JobVariation.Description }}
                                                                        </a>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <span style="margin-left: 10px">{{
                                                                            variationItem.Units | imperial: variationItem.IsImperial
                                                                        }}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span style="margin-left: 10px">&#64;</span>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <span style="margin-left: 10px">{{
                                                                            variationItem.UnitCost | bxCurrency
                                                                        }}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span style="margin-left: 10px">=</span>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <span style="margin-left: 10px">{{
                                                                            variationItem.TotalCost | bxCurrency
                                                                        }}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span
                                                                            style="margin-left: 10px"
                                                                            class="label"
                                                                            [ngClass]="{
                                                                                'label-inverse':
                                                                                    variationItem.JobVariation.Status === 'Pending',
                                                                                'label-warning':
                                                                                    variationItem.JobVariation.Status === 'Sent',
                                                                                'label-success':
                                                                                    variationItem.JobVariation.Status === 'Accepted' ||
                                                                                    variationItem.JobVariation.Status ===
                                                                                        'Digitally Accepted',
                                                                                'label-danger':
                                                                                    variationItem.JobVariation.Status === 'Rejected',
                                                                            }"
                                                                            >{{ variationItem.JobVariation.Status }}</span
                                                                        >
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <h5 *ngIf="item.actualOrderItems?.length" class="margin-bottom-0">
                                                            <strong>Related Orders</strong>
                                                        </h5>
                                                        <table *ngIf="item.actualOrderItems?.length">
                                                            <tbody>
                                                                <tr class="height-30" *ngFor="let actualOrderItem of item.actualOrderItems">
                                                                    <td>
                                                                        <a (click)="viewOrder(actualOrderItem.order)">
                                                                            {{ actualOrderItem.order.OrderNumber }} -
                                                                            {{ actualOrderItem.supplier }}
                                                                            {{
                                                                                actualOrderItem.reference
                                                                                    ? '(#' + actualOrderItem.reference + ')'
                                                                                    : ''
                                                                            }}
                                                                        </a>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <span style="margin-left: 10px">{{
                                                                            actualOrderItem.quantity
                                                                                | imperial: actualOrderItem.orderItem.IsImperial
                                                                        }}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span style="margin-left: 10px">&#64;</span>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <span style="margin-left: 10px">{{
                                                                            actualOrderItem.unitCost | bxCurrency
                                                                        }}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span style="margin-left: 10px">=</span>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <span style="margin-left: 10px">{{
                                                                            actualOrderItem.totalCost | bxCurrency
                                                                        }}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span
                                                                            style="margin-left: 10px"
                                                                            class="label"
                                                                            [ngClass]="{
                                                                                'label-inverse':
                                                                                    actualOrderItem.order.OrderStatus === 'Unsent',
                                                                                'label-warning':
                                                                                    actualOrderItem.order.OrderStatus === 'Sent',
                                                                                'label-info':
                                                                                    actualOrderItem.order.OrderStatus === 'PartReceived',
                                                                                'label-success':
                                                                                    actualOrderItem.order.OrderStatus === 'Received' ||
                                                                                    actualOrderItem.order.OrderStatus === 'Completed',
                                                                                'label-danger':
                                                                                    actualOrderItem.order.OrderStatus === 'Cancelled',
                                                                            }"
                                                                            >{{ actualOrderItem.order.OrderStatus }}</span
                                                                        >
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                    <div class="btn-group margin-top-5" *ngIf="editModes.items">
                                        <button
                                            type="button"
                                            *ngIf="job().InvoiceMethod !== 2"
                                            class="btn btn-success"
                                            (appSingleClick)="addItem(jobItem, itemsForm)">
                                            <i class="ti-plus"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-warning"
                                            (click)="stopEditing(itemsForm)"
                                            [disabled]="!itemsForm.valid">
                                            <i class="ti-check"></i>
                                        </button>
                                        <button type="button" class="btn btn-default" (click)="cancelEditing()">
                                            <i class="ti-close"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </accordion-group>
                    </accordion>
                </div>
            </div>
        </form>
    </div>
</div>

<help-note-wrapper
    title="{{ 'helpNotes.jobs.actuals.title' | translate }}"
    url="{{ 'helpNotes.jobs.actuals.url' | translate }}"
    footer="Read more in our FAQ’s"
    setting="NoteJobItemList"
    [expanded]="true"
    [videoList]="'helpNotes.jobs.actuals.videos' | translate">
    {{ 'helpNotes.jobs.actuals.text' | translate }}
</help-note-wrapper>

<div class="padding-20"></div>

<footer class="fixed-footer hidden-print" [ngClass]="'main-content--nav-v2-' + layoutService.getNavV2Layouts()">
    <div class="panel-tools hidden-on-mobile" style="z-index: 999" *ngIf="!selectedItems.length">
        <a
            class="btn btn-info btn-o btn-sm"
            tooltip="Show details"
            container="body"
            placement="left"
            *ngIf="!showSummaryDetails"
            (click)="showSummaryDetails = !showSummaryDetails">
            <i class="ti-angle-up"></i>
        </a>
        <a
            class="btn btn-info btn-o btn-sm"
            tooltip="Hide details"
            container="body"
            placement="left"
            *ngIf="showSummaryDetails"
            (click)="showSummaryDetails = !showSummaryDetails">
            <i class="ti-angle-down"></i>
        </a>
    </div>
    <div class="footer-inner">
        <div class="row row-item-add-dialog" role="dialog" *ngIf="addToQuoteRequestMode">
            <div class="col-md-2">
                <label class="add-items-label">Add items to</label>
            </div>
            <div class="col-md-6">
                <div class="typeahead-left-align typeahead-left-align--height-100 margin-top-10">
                    <input
                        legacy-css
                        id="add-to-ex-quote-typeahead"
                        [typeahead]="quoteRequests"
                        (typeaheadOnSelect)="selectedQuoteTypeAheadItem($event)"
                        typeaheadOptionField="Title"
                        [ngModel]="destinationQuoteRequest?.Title"
                        (ngModelChange)="destinationQuoteRequest = $event"
                        [adaptivePosition]="true"
                        class="form-control" />
                    <em>You can only add to Quote Requests that are in Draft mode.</em>
                </div>
            </div>
            <div class="col-md-1 text-left">
                <button
                    id="AddToRFQ"
                    type="button"
                    class="btn btn-warning js-btn-add-to"
                    (click)="addItemsToAnotherRFQ()"
                    [disabled]="!destinationQuoteRequestSelected">
                    Add
                </button>
            </div>
            <div class="col-md-3"></div>
        </div>

        <div *ngIf="!selectedItems?.length && !showSummaryDetails">
            <div class="row hidden-on-mobile" style="line-height: 24px">
                <div class="col-xs-4 text-center">
                    <div class="form-group text-large margin-bottom-5 margin-top-5">Estimated (Ex)</div>
                    <h4>{{ job().EstimatedTotal | bxCurrency }}</h4>
                </div>
                <div class="col-xs-4 text-center">
                    <div class="form-group text-large margin-bottom-5 margin-top-5">Actual (Ex)</div>
                    <h4>{{ job().ActualTotal | bxCurrency }}</h4>
                </div>
                @if (!hasCompactJobs) {
                    <div class="col-xs-4 text-center">
                        <div class="form-group text-large margin-bottom-5 margin-top-5">Variance (Ex)</div>
                        <h4>
                            <strong>{{ job().VarianceTotal | bxCurrency }}</strong>
                             
                            <small
                                ><span
                                    class="label"
                                    [ngClass]="{ 'label-danger': job().VarianceTotal < 0, 'label-success': job().VarianceTotal > 0 }"
                                    *ngIf="job().VariancePercent !== 0">
                                    {{ job().VariancePercent }}%
                                </span>
                            </small>
                        </h4>
                    </div>
                }
            </div>
            <div class="row hidden-not-on-mobile" style="line-height: 24px">
                <div class="col-xs-4 text-center">
                    <div class="form-group text-normal margin-bottom-5 margin-top-5">Est. (Ex)</div>
                    <h5>{{ job().EstimatedTotal | bxCurrency }}</h5>
                </div>
                <div class="col-xs-4 text-center">
                    <div class="form-group text-normal margin-bottom-5 margin-top-5">Act. (Ex)</div>
                    <h5>{{ job().ActualTotal | bxCurrency }}</h5>
                </div>
                <div class="col-xs-4 text-center">
                    <div class="form-group text-normal margin-bottom-5 margin-top-5">Var. (Ex)</div>
                    <h5>
                        <strong>{{ job().VarianceTotal | bxCurrency }}</strong>
                         
                        <small
                            ><span
                                class="label"
                                [ngClass]="{ 'label-danger': job().VarianceTotal < 0, 'label-success': job().VarianceTotal > 0 }"
                                *ngIf="job().VariancePercent !== 0">
                                {{ job().VariancePercent }}%
                            </span>
                        </small>
                    </h5>
                </div>
            </div>
        </div>
        <div *ngIf="!selectedItems?.length && showSummaryDetails">
            <div class="row" style="line-height: 24px">
                <div class="col-xs-4 text-center">
                    <div class="form-group text-large margin-bottom-5 margin-top-5">Estimated (Ex)</div>
                    <h4>{{ job().EstimatedTotal | bxCurrency }}</h4>
                    <h5>Estimate: {{ estimatedTotal_Estimate | bxCurrency }}</h5>
                    @if (!hasCompactJobs) {
                        <h5>{{ 'general.variations' | translate }}: {{ estimatedTotal_Variations | bxCurrency }}</h5>
                        <h5>Other: {{ estimatedTotal_Other | bxCurrency }}</h5>
                    }
                </div>
                <div class="col-xs-4 text-center">
                    <div class="form-group text-large margin-bottom-5 margin-top-5">Actual (Ex)</div>
                    <h4>{{ job().ActualTotal | bxCurrency }}</h4>
                    <h5>Purchase Orders: {{ actualTotal_PurchaseOrders | bxCurrency }}</h5>
                    @if (!hasCompactJobs) {
                        <h5>Work Orders: {{ actualTotal_WorkOrders | bxCurrency }}</h5>
                        <h5>Other: {{ actualTotal_Other | bxCurrency }}</h5>
                    }
                </div>
                <div class="col-xs-4 text-center">
                    @if (!hasCompactJobs) {
                        <div class="form-group text-large margin-bottom-5 margin-top-5">Variance (Ex)</div>
                        <h4>
                            <strong>{{ job().VarianceTotal | bxCurrency }}</strong>
                             
                            <small
                                ><span
                                    class="label"
                                    [ngClass]="{ 'label-danger': job().VarianceTotal < 0, 'label-success': job().VarianceTotal > 0 }"
                                    *ngIf="job().VariancePercent !== 0">
                                    {{ job().VariancePercent }}%
                                </span>
                            </small>
                        </h4>
                    }
                </div>
            </div>
        </div>
        <div class="row" *ngIf="selectedItems?.length">
            <div class="col-xs-12 text-center hidden-on-mobile">
                <button
                    id="create-new-quote-req"
                    type="button"
                    class="btn btn-success"
                    *ngIf="rfqJobs && permissionService.isAvailable('request-for-quote.maintain-rfqs.create-edit-send-rfq')"
                    [hidden]="quoteRequestSelected"
                    (appSingleClick)="createNewQuoteRequest()">
                    <i class="ti-plus"></i>
                    New Quote Request for {{ selectedItems.length }} item<span *ngIf="selectedItems.length !== 1">s</span>
                </button>
                <button
                    id="add-to-existing-quote-req"
                    type="button"
                    class="btn btn-success margin-left-20"
                    *ngIf="rfqJobs && permissionService.isAvailable('request-for-quote.maintain-rfqs.create-edit-send-rfq')"
                    [hidden]="quoteRequestSelected || !quoteRequests.length"
                    (appSingleClick)="setAddToQuoteRequestMode()">
                    <i class="ti-plus"></i>
                    Add to Existing Quote Request
                </button>
                <button
                    id="add-to-order"
                    type="button"
                    class="btn btn-success margin-left-20"
                    *ngIf="canCreateOrder"
                    (appSingleClick)="orderSelectedItems()">
                    <i class="ti-plus"></i>
                    Order {{ selectedItems.length }} item<span *ngIf="selectedItems.length !== 1">s</span>
                </button>
                @if ((canCreateOrder && hasExistingOrder) || (canCreateVariation && hasExistingVariation)) {
                    <button
                        id="add-to-existing-order-variation"
                        type="button"
                        class="btn btn-success margin-left-20"
                        (appSingleClick)="addItemsToAnotherOrderOrVariation()">
                        <i class="ti-plus"></i>
                        Add to Existing Order
                        @if (canCreateVariation) {
                            or {{ 'general.variation' | translate }}
                        }
                    </button>
                }
                <button
                    id="add-to-variation"
                    type="button"
                    class="btn btn-primary margin-left-20"
                    *ngIf="canCreateVariation"
                    (click)="variationSelectedItems()">
                    <i class="ti-plus"></i>
                    {{ 'general.variation' | translate }} {{ selectedItems.length }} item<span *ngIf="selectedItems.length !== 1">s</span>
                </button>
                <button type="button" class="btn btn-default margin-left-20" (click)="clearSelectedItems()">Cancel</button>
            </div>
            <div class="col-xs-12 text-center hidden-not-on-mobile">
                <button
                    id="add-to-order-mobile"
                    type="button"
                    class="btn btn-success btn-sm"
                    (click)="orderSelectedItems()"
                    *ngIf="canCreateOrder">
                    <i class="ti-plus"></i>
                    Order {{ selectedItems.length }} item<span *ngIf="selectedItems.length !== 1">s</span>
                </button>
                <button
                    id="add-to-variation-mobile"
                    type="button"
                    class="btn btn-primary btn-sm margin-left-10"
                    *ngIf="canCreateVariation"
                    (click)="variationSelectedItems()">
                    <i class="ti-plus"></i>
                    {{ 'general.variation' | translate }} {{ selectedItems.length }} item<span *ngIf="selectedItems.length !== 1">s</span>
                </button>
                <button
                    id="cancel-select-mobile"
                    type="button"
                    class="btn btn-default btn-sm margin-left-10"
                    (click)="clearSelectedItems()">
                    ×
                </button>
            </div>
        </div>
    </div>
</footer>
